import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { i18nInit } from './locales/index.ts';
import CssBaseline from '@mui/material/CssBaseline';
import { FacilityThemeProvider } from './shared/lib/providers/FacilityThemeProvider.tsx';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LoaderProvider } from './pages/components/LoaderContext.tsx';
import { AuthProvider } from './pages/components/AuthContext.tsx';
import SessionManager from './pages/components/SessionManager.tsx';
import { FontSizeProvider } from '@qler-view/shared_lib/src/shared/lib/providers/FontSizeContext';

i18nInit();

// Initialize React Query Client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 2, // Retry failed requests twice
      refetchOnWindowFocus: false, // Disable refetch on window focus
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <FacilityThemeProvider>
    <StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <CssBaseline />

          <FontSizeProvider>
            <AuthProvider>
              <SessionManager />
              <LoaderProvider>
                <App />
              </LoaderProvider>
            </AuthProvider>
          </FontSizeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </StrictMode>
  </FacilityThemeProvider>
);
